import _extends from "@babel/runtime/helpers/extends";
import { getUUID } from "../utils";
import EventManager from "./eventManager";
var GETPRINTERS = 'getPrinters'; // 获取打印机列表
var GETPRINTERCONFIGBYPRINTERNAME = 'getPrinterConfig'; // 通过打印机名称获取打印机配置
var SETPRINTERCONFIG = 'setPrinterConfig'; // 设置打印机配置
var GETPRINRTASKSTATUS = 'print'; // 获取下发打印任务收到确认返回结果
var NOTIFYPRINTRESULT = 'notifyPrintResult'; // 获取打印结果返回
var GETTASKSTATUSBYTASKID = 'getTaskStatus'; // 指定taskID获取打印结果
var GETGLOBALCONFIG = 'getGlobalConfig'; // 获取全局配置
var SETGLOBALCONFIG = 'setGlobalConfig'; // 设置全局配置
var GETAGENTINFO = 'getAgentInfo'; // 获取客户端版本信息
var GETPRINTCONFIGNAMELIST = 'getPrintConfigNameList'; // 获取打印配置列表
var BUSINESSTYPE = 1; // 业务类型
var MESSAGETYPE = 6; // 新版消息类型
var CONFIGMESSAGETYPE = 5; // 打印配置消息类型
var OLDPRINTMESSAGETYPE = 3; // 旧版打印消息类型
var OLDGETCONFIGMESSAGETYPE = 5; // 旧版获取打印配置
var CAINIAO = 'CAINIAO'; // 菜鸟源
var PDD = 'PDD'; // 拼多多
var JD = 'JD'; // 京东
var BYTE = 'BYTE'; // 字节 todo 参考
var KUAISHOU = 'KUAISHOU'; // 快手
var VIP = 'VIP'; // 唯品会
var HUAWEI = 'HUAWEI'; // 华为商城
var XHS = 'XHS'; // 小红书
var PRINTRESULTNOTIFY = 'PrintResultNotify'; // 拼多多打印结果
var SUCCESS = 'success';
var FAILED = 'failed';
var NOTIFYPRINTERROR = 'notifyPrintError'; // 打印失败
var commConfig = {
  bussinessType: BUSINESSTYPE,
  messageType: MESSAGETYPE
};
var DOLOGHOST = {
  daily: 'http://ibird-print.cainiao.test:7001',
  pre: 'https://ibird-platform-pre.cainiao.com',
  online: 'https://ibird-print.cainiao.com'
};
var COMMENDCONFIG = {
  getPrinters: function getPrinters() {
    return _extends({}, commConfig, {
      data: {
        requestID: getUUID(),
        version: '1.0',
        cmd: GETPRINTERS
      }
    });
  },
  getPrinterConfig: function getPrinterConfig(printer) {
    if (printer === void 0) {
      printer = '';
    }
    return _extends({}, commConfig, {
      data: {
        requestID: getUUID(),
        version: '1.0',
        cmd: GETPRINTERCONFIGBYPRINTERNAME,
        printer: printer
      }
    });
  },
  setPrinterConfig: function setPrinterConfig(config) {
    if (config === void 0) {
      config = {};
    }
    return _extends({}, commConfig, {
      data: {
        requestID: getUUID(),
        version: '1.0',
        cmd: SETPRINTERCONFIG
      },
      printer: config
    });
  },
  printData: function printData(config) {
    var _config$printConfig = config.printConfig,
      printConfig = _config$printConfig === void 0 ? {} : _config$printConfig,
      _config$data = config.data,
      data = _config$data === void 0 ? [] : _config$data;
    var _printConfig$dataSour = printConfig.dataSource,
      dataSource = _printConfig$dataSour === void 0 ? CAINIAO : _printConfig$dataSour,
      _printConfig$traceId = printConfig.traceId,
      traceId = _printConfig$traceId === void 0 ? '' : _printConfig$traceId,
      pdfPrint = printConfig.pdfPrint;
    var taskID = "" + new Date().getTime() + getUUID();
    try {
      EventManager.Instance.addTaskCache(taskID, traceId);
    } catch (e) {
      console.error(e);
    }
    if (dataSource === CAINIAO) {
      if (EventManager.Instance.supposeCloud) {
        return _extends({
          requestID: getUUID(),
          version: '1.0',
          cmd: GETPRINRTASKSTATUS,
          task: {
            taskID: taskID,
            preview: printConfig.preview,
            printer: printConfig.printer,
            previewType: printConfig.previewType || 'pdf',
            printType: printConfig.printType,
            documents: data
          },
          pageSession: {
            pageName: printConfig.pageName || '',
            pageCode: printConfig.pageCode || '',
            pageUrl: window.location.href
          }
        }, printConfig);
      }
      var nextConfig = _extends({}, commConfig, {
        configName: printConfig.configName,
        data: _extends({
          requestID: getUUID(),
          version: '1.0',
          cmd: GETPRINRTASKSTATUS,
          task: {
            taskID: taskID,
            preview: printConfig.preview,
            printer: printConfig.printer,
            previewType: printConfig.previewType || 'pdf',
            documents: data,
            printType: ''
          },
          pageSession: {
            pageName: printConfig.pageName || '',
            pageCode: printConfig.pageCode || '',
            pageUrl: window.location.href
          }
        }, printConfig)
      });
      if (pdfPrint) {
        nextConfig.data.task.printType = 'dirctPrint';
      }
      return nextConfig;
    }
    if (dataSource === PDD) {
      return {
        ERPId: printConfig.ERPId,
        cmd: 'print',
        requestID: getUUID(),
        task: {
          documents: data,
          notifyType: ['print'],
          preview: printConfig.preview,
          previewType: printConfig.previewType || 'pdf',
          printer: printConfig.printer,
          taskID: taskID
        },
        version: '1.0'
      };
    }
    if (dataSource === JD) {
      return {
        orderType: printConfig.preview ? 'PRE_View' : 'PRINT',
        key: taskID,
        parameters: _extends({
          printName: printConfig.printer
        }, data)
      };
    }
    if (dataSource === BYTE) {
      return {
        cmd: 'print',
        requestID: getUUID(),
        version: '1.0',
        task: {
          taskID: taskID,
          preview: printConfig.preview,
          printer: printConfig.printer,
          documents: data
        }
      };
    }
    if (dataSource === KUAISHOU) {
      return {
        cmd: 'print',
        requestID: getUUID(),
        task: {
          documents: data,
          preview: printConfig.preview,
          previewType: printConfig.previewType || 'pdf',
          printer: printConfig.printer,
          taskID: taskID
        },
        version: '1.0'
      };
    }
    if (dataSource === VIP) {
      return {
        actionType: 'PRINT',
        traceId: taskID,
        storeId: printConfig.storeId,
        printParamDTO: data,
        printerName: printConfig.printer || printConfig.configName || ''
      };
    }
    if (dataSource === HUAWEI) {
      var _data$ = data[0],
        item = _data$ === void 0 ? {} : _data$; // data即documents，华为只会有一项@阿亨，{ Cmd, requestId, version, printDataList }
      var _ref = item,
        cmd = _ref.cmd;
      return _extends({}, item, {
        Cmd: cmd
      });
    }
    if (dataSource === XHS) {
      return {
        cmd: 'print',
        requestID: getUUID(),
        version: '1.0',
        task: {
          taskID: taskID,
          preview: printConfig.preview,
          printer: printConfig.printer,
          previewType: printConfig.previewType || 'pdf',
          documents: data
        }
      };
    }
    return null;
  },
  getTaskStatus: function getTaskStatus(taskID) {
    if (taskID === void 0) {
      taskID = [];
    }
    return _extends({}, commConfig, {
      data: {
        requestID: getUUID(),
        version: '1.0',
        cmd: GETTASKSTATUSBYTASKID,
        taskID: taskID
      }
    });
  },
  getGlobalConfig: function getGlobalConfig() {
    return _extends({}, commConfig, {
      data: {
        requestID: getUUID(),
        version: '1.0',
        cmd: GETGLOBALCONFIG
      }
    });
  },
  setGlobalConfig: function setGlobalConfig(notifyOnTaskFailure) {
    if (notifyOnTaskFailure === void 0) {
      notifyOnTaskFailure = false;
    }
    return _extends({}, commConfig, {
      data: {
        requestID: getUUID(),
        version: '1.0',
        cmd: SETGLOBALCONFIG,
        notifyOnTaskFailure: notifyOnTaskFailure
      }
    });
  },
  getAgentInfo: function getAgentInfo() {
    return _extends({}, commConfig, {
      data: {
        requestID: getUUID(),
        version: '1.0',
        cmd: GETAGENTINFO
      }
    });
  },
  getConfigName: function getConfigName() {
    return {
      bussinessType: BUSINESSTYPE,
      messageType: CONFIGMESSAGETYPE
    };
  },
  getPrintConfigNameList: function getPrintConfigNameList() {
    return {
      bussinessType: BUSINESSTYPE,
      messageType: MESSAGETYPE,
      data: {
        requestID: getUUID(),
        version: '1.0',
        cmd: GETPRINTCONFIGNAMELIST
      }
    };
  }
};
export { GETPRINTERS, GETPRINTERCONFIGBYPRINTERNAME, SETPRINTERCONFIG, GETPRINRTASKSTATUS, NOTIFYPRINTRESULT, GETTASKSTATUSBYTASKID, GETGLOBALCONFIG, SETGLOBALCONFIG, GETAGENTINFO, BUSINESSTYPE, MESSAGETYPE, OLDPRINTMESSAGETYPE, OLDGETCONFIGMESSAGETYPE, COMMENDCONFIG, DOLOGHOST, CONFIGMESSAGETYPE, PRINTRESULTNOTIFY, SUCCESS, FAILED, NOTIFYPRINTERROR };